import React, { FormEvent, useState } from "react"

import { useDispatch } from "react-redux"
import { MainThunkDispatch } from "../../../../Reducers"
import {
    verifyOTP,
    skipOTPVerification
} from "../../../../Actions/Auth/AuthActions"
import { safePromise } from "../../../../Helpers/Functions/promise"
import QRCode from "qrcode.react"
import { Button, SingleLineTextInput } from "dash-styled"
import { AuthUser } from "../../../../Models/Client/User"
import { Redirect } from "react-router"
import { routePaths } from "../../../../Routes"
import { useBoolean } from "../../../../Hooks/useBoolean"
import { useAppState } from "../../../../Hooks/useReduxState"
import { selectCurrentUserSession } from "../../../../Helpers/Functions/Selectors/auth"

export type Props = {
    squashSuccessMessage: boolean
    onSuccess?: () => void
}

export const VerifyOTPForm = ({ onSuccess, squashSuccessMessage }: Props) => {
    const session = useAppState(selectCurrentUserSession)
    const [setupOTP, , skipSetupOTP] = useBoolean(!!session?.code)
    const [otp, setOtp] = useState("")
    const dispatch = useDispatch<MainThunkDispatch>()

    if (!session) {
        return <Redirect to={routePaths.authSignIn()} />
    }

    const handleOTP = async (user: AuthUser, code: string): Promise<void> => {
        const { error } = await safePromise(
            dispatch(verifyOTP(user, code, squashSuccessMessage))
        )
        if (onSuccess !== undefined && error === undefined) {
            onSuccess()
        }
    }

    const proceedWithLogin = async (): Promise<void> => {
        const { error } = await safePromise(
            dispatch(skipOTPVerification(squashSuccessMessage))
        )
        if (onSuccess !== undefined && error === undefined) {
            onSuccess()
        }
    }

    const handleSubmit = (e?: FormEvent) => {
        e?.preventDefault()
        handleOTP(session.currentUser, otp)
    }

    return (
        <>
            {setupOTP ? (
                <>
                    <div className="mx-auto">
                        <h2 className="text-center font-semibold">
                            Setup multi factor authentication
                        </h2>
                        {session.currentUser && (
                            <QRCode
                                className="mx-auto my-8"
                                value={
                                    "otpauth://totp/AWSCognito:" +
                                    session.currentUser.username +
                                    "?secret=" +
                                    session.code +
                                    "&issuer=Cognito"
                                }
                            />
                        )}
                        <ol className="list-disc space-y-2 my-8 mx-4">
                            <li> Download an authenticator app</li>
                            <li> Scan the QR Code above</li>
                            <li>click "Next" to enter the generated code</li>
                        </ol>
                    </div>
                    <div className="flex flex-col space-y-4">
                        <Button onClick={() => skipSetupOTP()}>Next</Button>
                        <Button
                            testId="skip-otp-button"
                            color="white"
                            onClick={proceedWithLogin}
                        >
                            Skip for now
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <p className="mb-10">
                        {" "}
                        Enter the code shown in your authenticator app{" "}
                    </p>
                    <form onSubmit={handleSubmit}>
                        <SingleLineTextInput
                            autoFocus
                            name="code"
                            type="text"
                            value={otp}
                            onChange={e => setOtp(e.target.value)}
                            className="pb-4"
                        />
                        <div className="flex mt-10">
                            <Button type="submit"> Submit </Button>
                        </div>
                    </form>
                </>
            )}
        </>
    )
}
